import createActions from "helpers/actionCreator"
import { takeEvery, select, call, put, takeLatest } from "redux-saga/effects"
import { Creators as notificationCreators } from "modules/notifications/model"
import { put as apiPut, get as apiGet } from "api"
import { TooManyRequestsError } from "api/errors"
import { secondsToTimePhrase } from "helpers/dates"
import { createReducer } from "reduxsauce"

const EMPTY_ARRAY = []
// `createActions` is use to create both action types and creators.
// First param is the action prefix (without a finishing /)
// Second param is a list of action to create, with a list of parameters.
export const { Types, Creators } = createActions("ompnt/modules/members", {
  resendInvite: ["id"],
  openMemberFeatures: ["memberId"],
  setMemberFeatures: ["features"],
})

// Action handlers would go here, for example:
const DEFAULT_STATE = {
  memberFeatures: EMPTY_ARRAY,
  memberFeaturesLoading: false,
}

function handleSetMemberFeatures(state, { features }) {
  return { ...state, memberFeatures: features, memberFeaturesLoading: false }
}

function handleOpenMemberFeatures(state) {
  return { ...state, memberFeaturesLoading: true }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_MEMBER_FEATURES]: handleSetMemberFeatures,
  [Types.OPEN_MEMBER_FEATURES]: handleOpenMemberFeatures,
})

// Side effects are handled as react sagas. In this case, we are calling an API and handling the return.
function* handleResendInvite({ id }) {
  const { account } = yield select(state => ({
    account: state.global.selected.account,
  }))
  try {
    yield call(apiPut, `/api/${account}/members/${id}/resend-invitation`)
    yield put(notificationCreators.add("success", null, "Invitation sent."))
  } catch (err) {
    let error = "An unknown error occurred while sending the invite."

    if (err instanceof TooManyRequestsError) {
      const timePhrase = secondsToTimePhrase(err.retryAfter)
      error = `Too many invitations sent. Please retry ${timePhrase}.`
    }

    yield put(notificationCreators.add("error", null, error))
  }
}

function* loadMemberFeatures({ memberId }) {
  try {
    const features = yield call(apiGet, `/api/admin/users/${memberId}/features`)
    yield put(Creators.setMemberFeatures(features))
  } catch {
    const error = "An unknown error occurred while fetching the member features."
    yield put(notificationCreators.add("error", null, error))
  }
}

// All functions named `saga` are automatically loaded by the saga manager in `new/model/saga.js`
export function* saga() {
  yield takeEvery([Types.RESEND_INVITE], handleResendInvite)
  yield takeLatest([Types.OPEN_MEMBER_FEATURES], loadMemberFeatures)
}
